// ECharts 按需引入配置
// 只引入项目中实际使用到的图表类型和组件，减小打包体积
import * as echarts from "echarts/core";

// 图表类型
import { LineChart, BarChart, PieChart, ScatterChart, HeatmapChart, RadarChart } from "echarts/charts";

// 组件
import {
  GridComponent,
  TooltipComponent,
  LegendComponent,
  TitleComponent,
  DataZoomComponent,
  MarkLineComponent,
  ToolboxComponent,
  CalendarComponent,
  VisualMapComponent,
  RadarComponent,
} from "echarts/components";

// 渲染器和特性
import { CanvasRenderer } from "echarts/renderers";
import { LabelLayout, UniversalTransition } from "echarts/features";

import type { EChartsOption } from "echarts";

// 注册所有需要的组件
echarts.use([
  // 图表类型
  LineChart,
  BarChart,
  PieChart,
  ScatterChart,
  HeatmapChart,
  RadarChart,
  // 组件
  GridComponent,
  TooltipComponent,
  LegendComponent,
  TitleComponent,
  DataZoomComponent,
  MarkLineComponent,
  ToolboxComponent,
  CalendarComponent,
  VisualMapComponent,
  RadarComponent,
  // 渲染器和特性
  CanvasRenderer,
  LabelLayout,
  UniversalTransition,
]);

export default echarts;
export type { EChartsOption };
